import { TransformNode } from "@babylonjs/core/Meshes/transformNode";
import { SceneElement } from "./SceneElement";
/**
 * TODO: This is only a placeholder for now. The final implementation is following later.
 */
export class GroupElement extends SceneElement {
    get childElements() {
        return (this.mChildElements);
    }
    constructor(pModel) {
        super(pModel, new TransformNode("", pModel.scene));
        this.mChildElements = [];
    }
}
